import CountWords from '@/src/components/CountWords/CountWords';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
import { get } from 'lodash';
import React from 'react';
import { Form, Input } from 'src/components/Antd';
import { OriCheckbox as Checkbox } from 'src/components/Antd/Checkbox/Checkbox';
import Tip from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/DisabledSectionTip';
import SectionWrapper from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/SectionWrapper';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const Item = Form.Item;

const CommentBox = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    //data, onChange,
    disableEdit,
    setHasModified,
    isPrimary,
  } = props;
  //   const enabled = get(data, 'enabled');
  //   const title = get(data, 'title');
  //   const placeholder = get(data, 'placeholder');
  const handleHasModified = () => {
    setHasModified(true);
  };
  const handleOnEnableChange = (e) => {
    handleHasModified();
    // const _enabled = e.target.checked;
    // const _data = { ...data };
    // _data.enabled = _enabled;
    // if (onChange) {
    //   onChange(_data);
    // }
  };

  const handleOnTitleChange = (title) => {
    handleHasModified();
    // const _data = { ...data };
    // _data.title = title;
    // if (onChange) {
    //   onChange(_data);
    // }
  };

  const handleOnPlaceholderChange = (title) => {
    handleHasModified();
    // const _data = { ...data };
    // _data.placeholder = placeholder;
    // if (onChange) {
    //   onChange(_data);
    // }
  };

  return (
    <SectionWrapper
      title={getI18n('salesChannelCheckout.index.checkoutCommentBox')}>
      <Item
        shouldUpdate={(prevValues, curValues) => {
          const pEnable = get(prevValues, 'commentBox.enabled');
          const cEnable = get(curValues, 'commentBox.enabled');

          return pEnable !== cEnable;
        }}
        noStyle>
        {({ getFieldValue }: any) => {
          const enabled = getFieldValue(['commentBox', 'enabled']);

          // const title = getFieldValue(['commentBox', 'title']);

          return (
            <React.Fragment>
              {isPrimary && (
                <Item name={['commentBox', 'enabled']} valuePropName='checked'>
                  <Checkbox
                    //  checked={enabled}
                    disabled={disableEdit}
                    onChange={handleOnEnableChange}
                    className={css.checkbox}>
                    {getI18n(
                      'salesChannelCheckout.index.enablecheckoutcommentbox',
                    )}
                  </Checkbox>
                </Item>
              )}
              {!enabled && !isPrimary && (
                <Tip
                  className={css.containerClassName}
                  tip={getI18n(
                    'salesChannelCheckout.index.enablecheckoutcommentboxunderprimarylanguage',
                  )}
                />
              )}
              {enabled ? (
                <Row
                  // containerClassName={css.containerClassName}
                  elements={[
                    {
                      child: (
                        <ItemWrapper
                          rightPart={
                            <Item
                              shouldUpdate={(prevValues, curValues) => {
                                const pEnable = get(
                                  prevValues,
                                  'commentBox.title',
                                );
                                const cEnable = get(
                                  curValues,
                                  'commentBox.title',
                                );
                                return pEnable !== cEnable;
                              }}
                              noStyle>
                              {({ getFieldValue }: any) => {
                                const title = getFieldValue([
                                  'commentBox',
                                  'title',
                                ]);

                                return (
                                  <CountWords
                                    count={(title || '').length}
                                    allCount={100}
                                  />
                                );
                              }}
                            </Item>
                          }
                          title={`${getI18n(
                            'salesChannelCheckout.index.title',
                          )}*`}>
                          <Input
                            disabled={disableEdit}
                            formProps={{
                              name: ['commentBox', 'title'],
                              rules: [
                                {
                                  required: true,
                                  message: getI18n('general.fieldCannotEmpty'),
                                },
                              ],
                            }}
                            size='large'
                            maxLength={100}
                            onChange={handleOnTitleChange}
                            // value={title}
                          />
                        </ItemWrapper>
                      ),
                    },
                    {
                      child: (
                        <ItemWrapper
                          rightPart={
                            <Item
                              shouldUpdate={(prevValues, curValues) => {
                                const pEnable = get(
                                  prevValues,
                                  'commentBox.placeholder',
                                );
                                const cEnable = get(
                                  curValues,
                                  'commentBox.placeholder',
                                );
                                return pEnable !== cEnable;
                              }}
                              noStyle>
                              {({ getFieldValue }: any) => {
                                const placeholder = getFieldValue([
                                  'commentBox',
                                  'placeholder',
                                ]);

                                return (
                                  <CountWords
                                    count={(placeholder || '').length}
                                    allCount={100}
                                  />
                                );
                              }}
                            </Item>
                          }
                          title={getI18n(
                            'salesChannelCheckout.index.contentPlaceholderOptional',
                          )}>
                          <Input
                            formProps={{
                              name: ['commentBox', 'placeholder'],
                            }}
                            size='large'
                            maxLength={100}
                            onChange={handleOnPlaceholderChange}
                            disabled={disableEdit}
                            // value={placeholder}
                          />
                        </ItemWrapper>
                      ),
                    },
                  ]}
                />
              ) : null}
            </React.Fragment>
          );
        }}
      </Item>
    </SectionWrapper>
  );
};
export default CommentBox;
